import { Transaction, TransactionArgument } from '@mysten/sui/transactions'
import { normalizeSuiAddress, normalizeSuiObjectId } from '@mysten/sui/utils'
import { VAULTS_CONFIG } from "../../constant";
import { handleError, handleMessageError, VaultsErrorCode } from "../../errors";
import { d } from "../tickMath";
import { bcs } from "@mysten/sui/bcs";
import { Vaults } from "../../modules/vaults";
import { getSuiCoin } from "../utils";

export class AftermathUtils {
  public static async getExchangeRateForStake(vaults: Vaults, sender_address: string, should_request_stake: boolean, swap_amount?: number): Promise<string> {
    const aftermath = VAULTS_CONFIG.config.aftermath
    if (aftermath === undefined) {
      return handleMessageError(VaultsErrorCode.StakeProtocolNotFound, 'the aftermath config is undefined')
    }
    const { staked_sui_vault, safe } = aftermath.config
    try {
      const tx = new Transaction()
      if (should_request_stake) {
        await this.requestStake(vaults, swap_amount || 1000000000, sender_address, tx)
      } else {
        tx.moveCall({
          target: `${aftermath.published_at}::staked_sui_vault::afsui_to_sui_exchange_rate`,
          typeArguments: [],
          arguments: [tx.object(staked_sui_vault), tx.object(safe)],
        })
      }

      const res: any = await vaults.getConfig().suiClient.devInspectTransactionBlock({
        transactionBlock: tx,
        sender: normalizeSuiAddress('0x0'),
      })

      if (should_request_stake) {
        const find_item = res.events.find((item: any) => {
          return item.type.includes('StakedEvent')
        })
        const { afsui_amount, sui_amount } = find_item.parsedJson
        return d(sui_amount).div(afsui_amount).toString()
      }

      const return_values = res.results[0]!.return_values[0][0]
      const rate = d(bcs.u128().parse(Uint8Array.from(return_values))).div(1000000000000000000)

      return rate.toString()
    } catch (error) {
      return handleError(VaultsErrorCode.FetchError, error as Error, { ["methodName"]: 'getExchangeRateForStake' })
    }
    return '0'
  }

  static async requestStake(vaults: Vaults, amount: number, sender_address: string, tx?: Transaction) {
    const aftermath = VAULTS_CONFIG.config.aftermath
    if (aftermath === undefined) {
      return handleMessageError(VaultsErrorCode.StakeProtocolNotFound, 'the aftermath config is undefined', {
        ["methodName"]: 'requestStake',
      })
    }

    tx = tx || new Transaction()
    const { staked_sui_vault, referral_vault, safe, validator_address } = aftermath.config

    const suiCoin = await getSuiCoin(vaults, amount, sender_address, tx)

    tx.moveCall({
      target: `${aftermath.published_at}::staked_sui_vault::request_stake_and_keep`,
      typeArguments: [],
      arguments: [
        tx.object(staked_sui_vault),
        tx.object(safe),
        tx.object(normalizeSuiObjectId('0x5')),
        tx.object(referral_vault),
        suiCoin,
        tx.pure.address(normalizeSuiObjectId(validator_address)),
      ],
    })
    return tx
  }

  static requestStakeCoin(tx: Transaction, sui_coin: TransactionArgument) {
    const aftermath = VAULTS_CONFIG.config.aftermath
    if (aftermath === undefined) {
      return handleMessageError(VaultsErrorCode.StakeProtocolNotFound, 'the aftermath config is undefined')
    }

    tx = tx || new Transaction()
    const { staked_sui_vault, referral_vault, safe, validator_address } = aftermath.config
    const ha_sui_coin = tx.moveCall({
      target: `${aftermath.published_at}::staked_sui_vault::request_stake`,
      typeArguments: [],
      arguments: [
        tx.object(staked_sui_vault),
        tx.object(safe),
        tx.object(normalizeSuiObjectId('0x5')),
        tx.object(referral_vault),
        sui_coin,
        tx.pure.address(normalizeSuiObjectId(validator_address)),
      ],
    })
    return ha_sui_coin
  }
}
